import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import { Fragment } from 'react/jsx-runtime';
import { useAppLoader } from '../../loader.ts';
import { useAuthInfo } from '../../use-auth-info.ts';
import { menuActions } from './menu-actions.tsx';
import { menu } from './menu.css.ts';
import { MoreMenu } from './more-menu.tsx';

const mobileMenuActions = [
  menuActions.Home,
  menuActions.Search,
  // menuActions.CreatePost,
  menuActions.Notifications,
  <MoreMenu key="more" />,
  menuActions.GuestAuth,
];

const tabletMenuActions = [
  menuActions.Home,
  menuActions.Marketplace,
  menuActions.StreamDeck,
  menuActions.Terminal,
  menuActions.LearningCenter,
  menuActions.Tools,
  menuActions.Notifications,
  menuActions.Enterprise,
  menuActions.Report,
  menuActions.Sources,
  menuActions.Admin,
  // menuActions.CreatePost,
];

const filterMenuActions = ({
  actions,
  authenticated,
  isAdmin,
}: {
  actions: typeof tabletMenuActions;
  authenticated: boolean;
  isAdmin: boolean;
}) =>
  actions.filter((action) => {
    if (action === menuActions.CreatePost) return authenticated;
    if (action === menuActions.GuestAuth) return !authenticated;
    if (action === menuActions.Admin) return isAdmin;
    if (action === menuActions.Sources) return isAdmin;
    return true;
  });

export const Menu = () => {
  const isTablet = useIsTablet();
  const { authenticated } = useAppLoader();
  const { isAdmin } = useAuthInfo();

  const actions = isTablet
    ? filterMenuActions({ actions: tabletMenuActions, authenticated, isAdmin })
    : filterMenuActions({ actions: mobileMenuActions, authenticated, isAdmin });

  return (
    <div className={menu}>
      {actions.map((action, index) => (
        <Fragment key={index}>{action}</Fragment>
      ))}
    </div>
  );
};
